import React, {useState} from 'react';
import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import {SubmitHandler, useForm} from "react-hook-form";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {TextField} from "src/lib/itaptec/components_forms/src";


interface SeccionCLFBCampoStopLossProps {
  detalle: CLFBDetalle,
  permiteEditar: boolean,
  tipoStopLoss: 'verde' | 'amarilla' | 'roja',
  handleConfirm: (data: CLFBDetalle) => void
}

const tiposStopLoss: Record<string, keyof CLFBDetalle> = {
  'verde': OperacionCLFBDetalleFields.StopLossVerde,
  'amarilla': OperacionCLFBDetalleFields.StopLossAmarilla,
  'roja': OperacionCLFBDetalleFields.StopLossRoja
}

function CLFBDetalleCampoStopLoss({
                                    detalle,
                                    permiteEditar,
                                    tipoStopLoss,
                                    handleConfirm,
                                  }: SeccionCLFBCampoStopLossProps) {

  const campoStopLoss = tiposStopLoss[tipoStopLoss]
  const [editable, setEditable] = useState<boolean>(false);

  const {control, handleSubmit} = useForm<CLFBDetalle>({
    resolver: zodResolver(schemaCLFBDetalle),
    defaultValues: {
      ...detalle
    }
  })

  const onUpdateDetalle: SubmitHandler<CLFBDetalle> = (data) => {
    handleConfirm(data)
  }

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        (permiteEditar && editable) ?
          <TextField
            <CLFBDetalle>

            control={control}
            name={campoStopLoss}
            label={'Stop Loss ' + tipoStopLoss}
            fullWidth
            sx={{minWidth: '200px', width: '100%'}}
          />
          :
          <Typography noWrap variant='body2'>
            {detalle[campoStopLoss]}
          </Typography>
      }
      {
        permiteEditar &&
        (
          editable ?
            <Box display='flex' justifyContent='center' flexWrap='nowrap'>
              <Tooltip title='Cancelar'>
                <IconButton onClick={() => setEditable(false)}>
                  <CancelIcon color='error'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Confirmar'>
                <IconButton onClick={handleSubmit(onUpdateDetalle)}>
                  <CheckCircleIcon color='success'/>
                </IconButton>
              </Tooltip>
            </Box>
            :
            <Tooltip title='Editar'>
              <IconButton onClick={() => setEditable(true)}>
                <EditIcon color='info'/>
              </IconButton>
            </Tooltip>
        )
      }
    </Box>
  )
}

export default CLFBDetalleCampoStopLoss;